import React from 'react';
import { Form } from '/src/components';
import { STOCK_STATUSES } from '/src/consts';

const ProductVariantSelect = ({
    setSelectedVariants,
    selectedVariants,
    sku,
    isLoading,
    variants,
    translate,
}) => (
    <Form.Select
        label={translate('Package size')}
        onChange={e => setSelectedVariants({ ...selectedVariants, [sku]: e.target.value })}
        disabled={isLoading}
        value={selectedVariants[sku]}
        aria-label="Weight"
    >
        {
            variants.sort((a, b) => a.product.weight - b.product.weight)
                .map(({
                    attributes,
                    product: { sku, stock_status, display_weight },
                }) => {
                    const { label } = attributes?.find(({ value_index }) => value_index === display_weight ) || {};

                    return (
                        <Form.Option
                            key={sku}
                            value={sku}
                            disabled={stock_status !== STOCK_STATUSES.IN_STOCK}
                        >
                            {label}
                        </Form.Option>
                    )
                })
        }
    </Form.Select>
);

export default ProductVariantSelect;
